<template>
  <div class="dashboard">
    <b-button
      size="sm"
      class="btn-icon btn-close"
      variant="flat-primary"
      @click="$emit('close')"
    >
      <feather-icon icon="XIcon" title="Cancelar" />
    </b-button>
    <report-user></report-user>
  </div>
</template>

<script>
import ReportUser from "./ReportUser.vue";
import { BButton } from "bootstrap-vue";

export default {
  components: {
    ReportUser,
    BButton
  },
};
</script>

<style>
</style>